import { Action } from "@ngrx/store";
import { Patient } from "./patient.model";
import { type } from "../../util";

/**
 * For each action type in an action group, make a simple
 * enum object for all of this group's action types.
 *
 * The 'type' utility function coerces strings into string
 * literal types and runs a simple check to guarantee all
 * action types in the application are unique.
 */
export const ActionTypes = {
  CREATE: type("[Patient] Create"),
  ADD: type("[Patient] Add"),
  ADD_SUCCESS: type("[Patient] Add Success"),
  ADD_FAIL: type("[Patient] Add Fail"),
  LIST: type("[Patient] List"),
  LIST_COMPLETE: type("[Patient] List Complete"),
  LIST_FAIL: type("[Patient] List Fail"),
  FILTER: type("[Patient] Filter"),
  LOAD: type("[Patient] Load"),
  LOAD_SUCCESS: type("[Patient] Load Success"),
  LOAD_FAIL: type("[Patient] Load Fail"),
  UPDATE: type("[Patient] Update"),
  UPDATE_SUCCESS: type("[Patient] Update Success"),
  UPDATE_FAIL: type("[Patient] Update Fail"),
  DELETE: type("[Patient] Delete"),
  DELETE_SUCCESS: type("[Patient] Delete Success"),
  DELETE_FAIL: type("[Patient] Delete Fail"),
  CLOSE: type("[Patient] Close"),
};

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */
export class CreatePatientAction implements Action {
  type = ActionTypes.CREATE;
}

export class ClosePatientAction implements Action {
  type = ActionTypes.CLOSE;
}

export class AddPatientAction implements Action {
  type = ActionTypes.ADD;
  constructor(public payload: Patient) {}
}

export class AddPatientSuccessAction implements Action {
  type = ActionTypes.ADD_SUCCESS;
  constructor(public payload: Patient) {}
}

export class AddPatientFailAction implements Action {
  type = ActionTypes.ADD_FAIL;
  constructor(public payload?: any) {}
}

export class ListPatientsAction implements Action {
  type = ActionTypes.LIST;
}

export class ListPatientsCompleteAction implements Action {
  type = ActionTypes.LIST_COMPLETE;
  constructor(public payload: Patient[]) {}
}

export class ListPatientsFailAction implements Action {
  type = ActionTypes.LIST_FAIL;
  constructor(public payload?: any) {}
}

export class FilterPatientsAction implements Action {
  type = ActionTypes.FILTER;
  constructor(public payload?: string) {}
}

export class LoadPatientAction implements Action {
  type = ActionTypes.LOAD;
  constructor(public payload: Patient) {}
}

export class LoadPatientSuccessAction implements Action {
  type = ActionTypes.LOAD_SUCCESS;
  constructor(public payload: Patient) {}
}

export class LoadPatientFailAction implements Action {
  type = ActionTypes.LOAD_FAIL;
  constructor(public payload?: any) {}
}

export class UpdatePatientAction implements Action {
  type = ActionTypes.UPDATE;
  constructor(public payload: Patient) {}
}

export class UpdatePatientSuccessAction implements Action {
  type = ActionTypes.UPDATE_SUCCESS;
  constructor(public payload: Patient) {}
}

export class UpdatePatientFailAction implements Action {
  type = ActionTypes.UPDATE_FAIL;
  constructor(public payload?: any) {}
}

export class DeletePatientAction implements Action {
  type = ActionTypes.DELETE;
  constructor(public payload: Patient) {}
}

export class DeletePatientSuccessAction implements Action {
  type = ActionTypes.DELETE_SUCCESS;
  constructor(public payload: Patient) {}
}

export class DeletePatientFailAction implements Action {
  type = ActionTypes.DELETE_FAIL;
  constructor(public payload?: any) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Action =
  | CreatePatientAction
  | ClosePatientAction
  | AddPatientAction
  | AddPatientSuccessAction
  | AddPatientFailAction
  | ListPatientsAction
  | ListPatientsCompleteAction
  | ListPatientsFailAction
  | FilterPatientsAction
  | LoadPatientAction
  | LoadPatientSuccessAction
  | LoadPatientFailAction
  | UpdatePatientAction
  | UpdatePatientSuccessAction
  | UpdatePatientFailAction
  | DeletePatientAction
  | DeletePatientSuccessAction
  | DeletePatientFailAction;



// WEBPACK FOOTER //
// /app/src/app/core/store/patient/patient.actions.ts